import { ContractStatus } from '@gi/enums/contract-status.enum';

export const CONTRACT_STATUS_LABEL: Record<ContractStatus, string> = {
  [ContractStatus.draft]: 'En cours',
  [ContractStatus.sent]: 'Envoyé',
  [ContractStatus.signed]: 'Signé',
  [ContractStatus.lost]: 'Perdu'
};
